import styled from 'styled-components';

export const Text = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.travelApproval.modal.modalTextColor};
  margin: 0 16px 16px;

  & > strong {
    font-weight: 600;
  }
`;
